import { render, staticRenderFns } from "./SlidingBayOtherDamages.vue?vue&type=template&id=36bac0f2&scoped=true"
import script from "./SlidingBayOtherDamages.vue?vue&type=script&lang=ts"
export * from "./SlidingBayOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bac0f2",
  null
  
)

export default component.exports